import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BrandCtx = createContext({ logo: null });

export function BrandProvider({ children }) {
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    axios.get(`${API}/brand`).then((r) => setLogo(r.data?.logo_data_url || null)).catch(() => {});
  }, []);
  return <BrandCtx.Provider value={{ logo, setLogo }}>{children}</BrandCtx.Provider>;
}
export const useBrand = () => useContext(BrandCtx);
